import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronRight, Shirt, ClipboardList } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSeo } from "@/lib/seo";
import CustomOrderRequest from "@/components/studio/CustomOrderRequest";
import VisualStudio from "@/components/studio/VisualStudio";

export default function CustomStudio() {
  useSeo(
    "Custom Order Studio — Collins Crafty Creations",
    "Create something uniquely yours. Submit a custom order request with your files, or design your own apparel in our visual studio."
  );
  const { user } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("request");

  if (user === false) {
    return (
      <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="studio-auth-gate">
        <Shirt size={40} className="mx-auto text-navy-royal" />
        <h1 className="font-serif text-3xl text-navy-dark mt-4">Custom Orders</h1>
        <p className="text-navy/60 mt-2">Sign in or create an account to submit and manage your custom orders.</p>
        <button
          onClick={() => navigate("/account?next=/shop/studio")}
          className="mt-6 rounded-md bg-navy-dark text-white px-6 py-3 text-xs font-bold uppercase tracking-[0.15em]"
          data-testid="studio-signin"
        >
          Sign In / Register
        </button>
      </div>
    );
  }

  return (
    <div data-testid="custom-studio">
      <div className="bg-slate-50 border-b border-silver-light">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-2 text-xs text-navy/60">
          <Link to="/" className="hover:text-navy-royal">Home</Link><ChevronRight size={12} />
          <Link to="/shop" className="hover:text-navy-royal">Collins Crafty Creations</Link><ChevronRight size={12} />
          <span className="text-navy-dark font-semibold">Custom Order Studio</span>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-6">
        <div className="inline-flex rounded-full bg-slate-100 p-1 text-sm font-semibold" data-testid="studio-tabs">
          <button
            onClick={() => setTab("request")}
            className={`inline-flex items-center gap-2 px-5 py-2 rounded-full transition-colors ${tab === "request" ? "bg-navy-dark text-white" : "text-navy/60"}`}
            data-testid="studio-tab-request"
          >
            <ClipboardList size={15} /> Custom Order Request
          </button>
          <button
            onClick={() => setTab("visual")}
            className={`inline-flex items-center gap-2 px-5 py-2 rounded-full transition-colors ${tab === "visual" ? "bg-navy-dark text-white" : "text-navy/60"}`}
            data-testid="studio-tab-visual"
          >
            <Shirt size={15} /> Visual Design Studio
          </button>
        </div>
      </div>

      {tab === "request" ? <CustomOrderRequest /> : <VisualStudio />}
    </div>
  );
}
